import React from 'react';
import { Button } from '@syneto/compass-react';
import PropTypes from 'prop-types';

// What a screen shows in place of its data when loading it failed. The toast that reports the same
// failure hides itself after a few seconds; this stays, so an empty screen is never mistaken for
// "there is nothing here", and it offers the retry. `subject` is the thing that could not be
// loaded ("The users"), and its text is deliberately different from the toast's.
export const LoadFailedMessage = ({ subject, onRetry }) => {
	return (
		<div role="alert" className="text-center my-5">
			<p className="text-muted">{`${subject} could not be loaded.`}</p>
			<Button role="secondary" onClick={onRetry}>
				Try again
			</Button>
		</div>
	);
};

LoadFailedMessage.propTypes = {
	subject: PropTypes.string.isRequired,
	onRetry: PropTypes.func.isRequired,
};
